import styled from 'styled-components';
import { Modal } from 'antd';
import YoutubeVideoCrossIcon from '../assets/svgIcons/YoutubeVideoCrossIcon';

const Wrapper = styled.div``;

type Props = {
  videoLink?: string,
  visible?: boolean;
  setVisible?: () => void;
} & typeof defaultProps;

const defaultProps = {
  videoLink: '',
  visible: false,
  setVisible: {},
};

/**
 * Converts any YouTube URL format to a proper embed URL with required parameters
 * for nested iframe contexts (like Salesforce).
 */
const getYouTubeEmbedUrl = (url: string): string => {
  if (!url) return '';

  let videoId = '';

  // Already an embed URL - extract the video ID
  if (url.includes('/embed/')) {
    const match = url.match(/\/embed\/([^?&]+)/);
    videoId = match ? match[1] : '';
  }
  // Standard watch URL: youtube.com/watch?v=VIDEO_ID
  else if (url.includes('watch?v=')) {
    const match = url.match(/[?&]v=([^&]+)/);
    videoId = match ? match[1] : '';
  }
  // Short URL: youtu.be/VIDEO_ID
  else if (url.includes('youtu.be/')) {
    const match = url.match(/youtu\.be\/([^?&]+)/);
    videoId = match ? match[1] : '';
  }

  if (!videoId) return url; // fallback to original if we can't parse

  // Build embed URL with parameters required for nested iframe contexts
  const params = new URLSearchParams({
    enablejsapi: '1',
    rel: '0',
    modestbranding: '1',
    playsinline: '1',
    fs: '1',
  });

  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
};

const VideoPopup = function VideoPopup(props: Props) {
  const { visible, videoLink, setVisible } = props;
  const embedUrl = getYouTubeEmbedUrl(videoLink);

  return (
    <Wrapper className="popup_wrapper">
      <Modal
        open={visible}
        onCancel={setVisible}
        centered
        destroyOnClose
        maskClosable
        width={854}
        getContainer=""
        closeIcon={<div className="cross-icon-x"><YoutubeVideoCrossIcon /></div>}
        wrapClassName="video-popup-wrapper"
      >
        {visible && embedUrl && (
          <iframe
            src={embedUrl}
            title="YouTube video player"
            className="videoFrame"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
          />
        )}
      </Modal>
    </Wrapper>
  );
};

VideoPopup.defaultProps = defaultProps;
export default VideoPopup;
